<template>
  <v-row>
    <v-col cols="12" md="8">
      <v-card
        :class="{
          'py-6 px-6': $vuetify.breakpoint.mdAndUp,
          'pa-5': $vuetify.breakpoint.smAndDown
        }"
        no-body
      >
        <span class="black--text text-h6 font-weight-black">{{ title }}</span>

        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-form v-model="formValidate" ref="form">
              <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
                <v-row>
                  <v-col>
                    <span class="px-1 grey--text text--darken-2">
                      วันที่เขียน
                    </span>
                    <span class="black--text">
                      {{ otherData.leaveAssignDateText }}
                    </span>
                    <span v-if="!isLeaveRelax">
                      <span class="px-1">
                        ,
                      </span>
                      <span class="px-1 ">
                        {{ otherData.leaveTypeName }}
                      </span>
                      <span class="info--text px-1">
                        {{ otherData.leaveTypeDesc }}
                      </span>
                    </span>
                  </v-col>
                </v-row>

                <v-row class="mb-n2">
                  <v-col cols="12">
                    <v-text-field
                      v-model="form.LeaveHead"
                      ref="leaveHead"
                      label="เรียน"
                      hide-details="auto"
                      :rules="[rules.required]"
                      required
                      outlined
                      dense
                      maxlength="255"
                    />
                  </v-col>
                </v-row>

                <v-row v-if="isLeaveSick">
                  <v-col cols="12" class="mb-n5">
                    <v-select
                      v-model="form.LeaveReasonID"
                      :items="leaveSickSelectList"
                      ref="leaveReasonID"
                      item-value="leaveReasonID"
                      item-text="leaveReasonNameTha"
                      label="เหตุผลลาป่วย"
                      :rules="!isLeaveSick ? [] : [rules.leavereason]"
                      required
                      outlined
                      dense
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row v-if="!isLeaveRelax" class="mb-n3">
                  <v-col cols="12">
                    <v-textarea
                      v-model="form.LeaveReason"
                      ref="leaveReason"
                      hide-details="auto"
                      :label="isLeaveRelax ? 'รายละเอียด' : 'เนื่องจาก'"
                      :rules="isLeaveRelax ? [] : [rules.required]"
                      counter
                      maxlength="255"
                      required
                      outlined
                      dense
                      height="70"
                    />
                  </v-col>
                </v-row>

                <v-row class="py-3">
                  <v-col cols="12" class="py-0">
                    <v-checkbox
                      v-model="otherData.leaveOneDay"
                      class="ma-0"
                      label="ลาวันเดียว"
                      hide-details="auto"
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-menu
                      v-model="beginMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          :value="beginDateText"
                          label="ลาตั้งแต่วันที่"
                          hide-details="auto"
                          append-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          @click:append="beginMenu = true"
                        />
                      </template>
                      <v-date-picker
                        no-title
                        v-model="form.LeaveBeginDate"
                        :locale="$lang === 'Tha' ? 'th' : 'en'"
                        @input="beginMenu = false"
                        :min="checkActiveDate"
                        @change="onChangeDaySelection()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pt-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-radio-group
                      v-model="form.LeaveBeginDayStatusID"
                      class="ma-0"
                      row
                      hide-details="auto"
                      @change="onChangeDaySelection()"
                    >
                      <v-radio label="เต็มวัน" value="ALL" />
                      <v-radio label="ครึ่งเช้า" value="AM" />
                      <v-radio label="ครึ่งบ่าย" value="PM" />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-show="form.LeaveAmountDay === 0">
                  <span class="px-1 error--text"
                    >* จำนวนวันลาไม่สามารถเป็น 0 วันได้</span
                  >
                </v-row>

                <v-row
                  v-if="
                    !(
                      form.LeaveBeginDayStatusID === 'AM' ||
                      otherData.leaveOneDay
                    )
                  "
                >
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pb-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-menu
                      v-model="finishMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                      ref="leaveAmountDay"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          :value="finishDateText"
                          :disabled="
                            form.LeaveBeginDayStatusID === 'AM' ||
                              otherData.leaveOneDay
                          "
                          label="ลาถึงวันที่"
                          hide-details="auto"
                          append-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          @click:append="finishMenu = true"
                        />
                      </template>
                      <v-date-picker
                        v-model="form.LeaveFinishDate"
                        :locale="$lang === 'Tha' ? 'th' : 'en'"
                        :min="
                          $dateFormat(form.LeaveBeginDate, {
                            addUnit: 'd',
                            addValue: 1
                          })
                        "
                        :disabled="
                          form.LeaveBeginDayStatusID === 'AM' ||
                            otherData.leaveOneDay
                        "
                        no-title
                        @input="finishMenu = false"
                        @change="onChangeDaySelection()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    :class="{ 'pt-1': $vuetify.breakpoint.mdAndDown }"
                  >
                    <v-radio-group
                      v-model="form.LeaveFinishDayStatusID"
                      class="ma-0"
                      row
                      hide-details="auto"
                      :disabled="
                        form.LeaveBeginDayStatusID === 'AM' ||
                          otherData.leaveOneDay
                      "
                      @change="onChangeDaySelection()"
                    >
                      <v-radio label="เต็มวัน" value="ALL" />
                      <v-radio label="ครึ่งเช้า" value="AM" />
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row class="py-3">
                  <v-col cols="12" lg="auto" class="py-0">
                    <v-checkbox
                      v-model="form.CheckSaturday"
                      class="ma-0"
                      label="นับวันเสาร์เป็นวันทำงาน"
                      hide-details="auto"
                      :disabled="isLeaveDeliver"
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                  <v-col cols="12" lg="auto" class="py-0">
                    <v-checkbox
                      v-model="form.CheckSunday"
                      class="ma-0"
                      label="นับวันอาทิตย์เป็นวันทำงาน"
                      hide-details="auto"
                      :disabled="isLeaveDeliver"
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                  <v-col cols="12" lg="auto" class="py-0">
                    <v-checkbox
                      v-model="form.CheckHoliday"
                      class="ma-0"
                      label="นับวันหยุดนักขัตฤกษ์เป็นวันทำงาน"
                      hide-details="auto"
                      :disabled="isLeaveDeliver"
                      @change="onChangeDaySelection()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="mt-n2">
                    <span
                      class="px-1 error--text"
                      v-text="otherData.warningMessage"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col />
                </v-row>

                <v-divider class=" mt-n8" />

                <v-row>
                  <v-col />
                </v-row>
                <v-row v-if="isLeaveRelax" class="mb-n3">
                  <v-col cols="12">
                    <v-textarea
                      v-model="form.LeaveReason"
                      ref="leaveReason"
                      hide-details="auto"
                      :label="isLeaveRelax ? 'หมายเหตุ (ถ้ามี)' : 'เนื่องจาก'"
                      :rules="isLeaveRelax ? [] : [rules.required]"
                      counter
                      maxlength="255"
                      required
                      outlined
                      dense
                      height="70"
                    />
                  </v-col>
                </v-row>
                <v-row class="mb-2">
                  <v-col cols="12" class="mt-n5">
                    <v-text-field
                      v-model="form.Address"
                      label="สามารถติดต่อได้ที่"
                      hide-details="auto"
                      outlined
                      dense
                      maxlength="255"
                    />
                  </v-col>
                </v-row>

                <v-row class="mt-n5">
                  <v-col cols="12" class=" pb-0 pt-3 mb-0  black--text">
                    <b> แนบเอกสารเพิ่มเติม</b>
                  </v-col>
                  <v-col
                    v-if="otherData.docName && form.KeepFileFlag"
                    cols="12"
                    class="sub-title2 py-0 pl-5 ma-0"
                  >
                    <span>เอกสารที่เคย upload ไว้ : </span>
                    <v-btn
                      class="primary--text text--darken-2"
                      text
                      @click="
                        onDownloadDocument({
                          leaveOrderID: leaveOrderId,
                          docFileName: otherData.docName
                        })
                      "
                    >
                      {{ otherData.docName }}
                    </v-btn>
                    <v-btn color="error" outlined @click="onRemoveAttachedFile">
                      ลบเอกสารแนบ
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      ref="docFileName"
                      label="แนบเอกสารเพิ่มเติม"
                      hide-details="auto"
                      accept=".jpg, .jpeg, .png, .pdf"
                      outlined
                      dense
                      show-size
                      @change="onSelectFile()"
                    />
                  </v-col>
                  <v-col cols="12" class="mt-n3">
                    <span class="grey--text"
                      >ขนาดไฟล์ไม่เกิน 2 MB และรองรับไฟล์นามสกุล .jpg, .png,
                      หรือ .pdf เท่านั้น</span
                    >
                  </v-col>
                </v-row>

                <v-row v-if="isLeaveRelax">
                  <v-col cols="12">
                    <v-radio-group
                      v-model="form.EmployeeApproveTypeID"
                      class="ma-0"
                      hide-details="auto"
                      :row="$vuetify.breakpoint.smAndUp"
                      @change="onChangeApproverType"
                    >
                      <v-radio label="ส่งต่อผู้ปฏิบัติงานแทน" value="UseWork" />
                      <v-radio
                        label="ส่งต่อผู้บังคับบัญชา/ผู้ตรวจสอบการลา/ผู้อนุมัติการลา"
                        value="Approve"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-row class="ml-1">
                      <div>
                        <span
                          v-if="!otherData.employeeApprove[$lang]"
                          class="title error--text"
                          ref="leaveApprover"
                        >
                          *
                        </span>
                        <b>{{ approverTitle + ' : ' }}</b>
                        <span
                          v-if="!otherData.employeeApprove[$lang]"
                          class="title error--text"
                        >
                          กรุณาเลือกผู้ส่งต่อ
                        </span>
                        <span
                          v-else
                          class="title success--text"
                          v-text="otherData.employeeApprove[$lang] || ''"
                        />
                      </div>
                      <div v-if="!otherData.employeeApprove[$lang]">
                        <v-btn
                          color="primary"
                          outlined
                          @click="openDialog()"
                          class="white--text ml-2"
                        >
                          <v-icon>mdi-plus</v-icon>
                          ค้นหารายชื่อ</v-btn
                        >
                        <div>
                          <span v-if="leaveApproverStatus" class=" error--text">
                            * กรุณาค้นหารายชื่อเพื่อส่งต่อ
                          </span>
                        </div>
                      </div>
                      <div v-else class="ml-2">
                        <v-btn
                          color="orange"
                          outlined
                          @click="openDialog()"
                          class="white--text"
                        >
                          <v-icon>mdi-pencil</v-icon>
                          เปลี่ยน</v-btn
                        >
                      </div>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="mt-4" align="center">
                  <v-col cols="12">
                    <v-btn
                      :color="
                        isEditMode ? 'warning darken-1' : 'primary darken-2'
                      "
                      depressed
                      large
                      @click="onSubmitForm()"
                      class="float-right"
                    >
                      {{ isEditMode ? 'บันทึกการแก้ไข' : 'บันทึกข้อมูล' }}
                    </v-btn>

                    <v-btn
                      large
                      outlined
                      color="grey"
                      :to="`/leave/pending/${$guid}`"
                      depressed
                      class="float-right mr-1"
                    >
                      ยกเลิก
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-col cols="12" md="4">
      <div class="fixposition align-self-start  hidden-sm-and-down shadowBox ">
        <v-card-title>
          <span class="black--text font-weight-black">
            สรุปการลา
          </span>
        </v-card-title>
        <v-card-text>
          <leave-cal-right-box
            :otherData="otherData"
            :form="form"
            :getdateNowThaFormat="getdateNowThaFormat"
            :isLeaveRelax="isLeaveRelax"
            :yearRelexcheck="yearRelexcheck"
            :leaveCalLimitDayQuota="leaveCalLimitDayQuota"
            :beginDateText="beginDateText"
            :finishDateText="finishDateText"
            :leaveBalanceQuota="leaveBalanceQuota"
          />
        </v-card-text>
      </div>
    </v-col>
    <!-- <v-col cols="12" md="4">
      <v-card class="pa-2 fixposition">
        <v-card-title>
          <span> ผลการลาพักผ่อน Nor </span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6"> <span>ในปีงบประมาณ</span> <span class="text--primary"> 2565</span> </v-col>
            <v-col cols="6">
              <v-chip small>06 กันยายน 2565</v-chip>
            </v-col>
          </v-row>

          <div class="text--primary">
            relating to or dependent on charity; charitable.<br />
            "an eleemosynary educational institution."
          </div>
        </v-card-text>
      </v-card>
    </v-col> -->

    <!-- Explan nav Footer  -->
    <v-col cols="12" class="hidden-md-and-up">
      <v-expand-transition>
        <v-footer app padless v-show="!isFooterShowAll">
          <v-card class="flex rounded-lg  rounded-b-0" elevation="10">
            <v-card-title class="mt-n4">
              <v-row>
                <v-col cols="6">
                  <span class="black--text text-h6 font-weight-black"
                    >สรุปการลา</span
                  >
                </v-col>
                <v-col cols="6" class="text-end">
                  <a @click="isFooterShowAll = true">
                    <span class="grey--text text-body-2">รายละเอียดทั้งหมด</span
                    ><v-icon class="" small>mdi-chevron-up</v-icon>
                  </a>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text class="mb-n2">
              <v-row class=" mt-n5">
                <v-col cols="3">
                  <span class="text--primary ">ต้องการลา</span>
                </v-col>
                <v-col cols="9" class="text-end">
                  <v-chip small color="#E7EDF5">
                    <span class=" primary--text text--darken-2">
                      {{ beginDateText }}</span
                    >
                    <span
                      v-if="
                        !(
                          form.LeaveBeginDayStatusID === 'AM' ||
                          otherData.leaveOneDay
                        )
                      "
                      class=" primary--text text--darken-2"
                    >
                      - {{ finishDateText }}
                    </span>
                  </v-chip>
                </v-col>
              </v-row>

              <v-row class="mt-n5">
                <v-col cols="6"> <span>จำนวนวันที่ต้องการลา</span> </v-col>
                <v-col cols="6" class="text-end">
                  <span
                    class="text-h3 mr-2 font-weight-black primary--text text--darken-2"
                    >{{ form.LeaveAmountDay }}</span
                  >
                  <span class="grey--text">วันทำการ</span>
                </v-col>
              </v-row>
              <v-row class="mt-n6 mb-n4" v-if="otherData.overLimitDay > 0">
                <v-col cols="6">
                  <span class="error--text">จำนวนวันลาเกินสิทธิ์</span>
                </v-col>
                <v-col cols="6" class="text-end">
                  <span class="text-h6 mr-2 font-weight-black error--text ">{{
                    otherData.overLimitDay
                  }}</span
                  ><span class="error--text">วัน</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-footer>
      </v-expand-transition>
    </v-col>
    <v-col cols="12" class="hidden-md-and-up">
      <v-expand-transition>
        <v-footer app padless v-show="isFooterShowAll">
          <v-card class="flex rounded-lg  rounded-b-0" elevation="10">
            <v-card-title class="mt-n4">
              <v-row>
                <v-col cols="6">
                  <span class="black--text text-h6 font-weight-black"
                    >สรุปการลา</span
                  >
                </v-col>
                <v-col cols="6" class="text-end">
                  <a @click="isFooterShowAll = false">
                    <span class="grey--text text-body-2"
                      >รายละเอียดทั้งหมด</span
                    >
                    <v-icon class="" small>mdi-chevron-down</v-icon>
                  </a>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <leave-cal-right-box
                :otherData="otherData"
                :form="form"
                :getdateNowThaFormat="getdateNowThaFormat"
                :isLeaveRelax="isLeaveRelax"
                :yearRelexcheck="yearRelexcheck"
                :leaveCalLimitDayQuota="leaveCalLimitDayQuota"
                :beginDateText="beginDateText"
                :finishDateText="finishDateText"
                :leaveBalanceQuota="leaveBalanceQuota"
              />
            </v-card-text>
          </v-card>
        </v-footer>
      </v-expand-transition>
    </v-col>

    <v-col cols="12">
      <v-dialog v-model="conDialogOnSubmitForm" max-width="500px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text"
            >ยืนยันการบันทึกการลา</v-card-title
          >

          <v-card-text class="mb-4">
            <v-divider class="mb-2"></v-divider>
            <span class="text-body-1" v-if="isLeaveRelax"
              >ส่งรายการลาไปยังผู้ปฏิบัติงานแทน
            </span>
            <span class="text-body-1" v-else>ส่งรายการลาไปยัง </span>
            <span class="font-weight-bold">
              {{ otherData.employeeApprove[$lang] }}</span
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn
                class="white--text mr-2"
                color="error"
                outlined
                @click="conDialogOnSubmitForm = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                class="white--text mr-2"
                color="success"
                @click="conOnSubmitForm"
                >ยืนยัน
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12">
      <v-dialog v-model="conDialogOnSubmitSkipUsework" max-width="500px">
        <v-card class="py-2">
          <v-card-title class="headline Black--text"
            >ท่านไม่ได้เลือกส่งต่อผู้ปฏิบัติงานแทน ต้องการทำรายการต่อหรือไม่
            ?</v-card-title
          >

          <v-card-text class="mb-5">
            <v-divider class="mb-2"></v-divider>
            <span class="text-body-1">ส่งรายการลาไปยัง:</span>
            <span class="font-weight-bold">
              {{ otherData.employeeApprove[$lang] }}</span
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n8">
              <v-btn
                class="white--text mr-2"
                color="error"
                outlined
                @click="conDialogOnSubmitSkipUsework = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                class="white--text mr-2"
                color="success"
                @click="conOnSubmitForm"
                >ยืนยัน
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12">
      <v-dialog v-model="loading1" hide-overlay persistent max-width="300">
        <v-card color="primary" dark>
          <v-card-text>
            กำลังบันทึก...
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card> </v-dialog
    ></v-col>
    <v-col cols="12">
      <v-dialog v-model="searchDialog" max-width="800">
        <v-card>
          <v-card-title class="headline Black--text">
            ค้นหารายชื่อ
          </v-card-title>
          <v-card-text class="mb-2">
            <v-divider class="mb-2"></v-divider>
            <leave-search-employee
              :selected-employee="form.EmployeeApproveID"
              :list="employeeApproveList"
              :isload="loading"
              @search="onSearchEmpApprove"
              @select="onSelectApprover"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="mr-4 mt-n5 mb-3">
              <v-btn
                class="white--text mr-2"
                color="grey"
                outlined
                @click="searchDialog = false"
                >ยกเลิก
              </v-btn>
              <v-btn
                class="white--text "
                color="primary"
                @click="btnSubmitSelect"
                :disabled="checkSearch"
                >บันทึก
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import LeaveSearchEmployee from '@/components/leave/LeaveForm/LeaveSearchEmployeeDialogAuto'
import LeaveCalRightBox from '@/components/leave/LeaveCalRightBox'
export default {
  components: {
    LeaveSearchEmployee,
    LeaveCalRightBox
  },

  props: {
    title: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: ''
    },

    titleshort: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      conDialogOnSubmitForm: false,
      loading1: false,
      loading: false,
      formValidate: null,
      beginMenu: false,
      finishMenu: false,
      searchDialog: false,
      form: {},
      employeeApproveDefualt: {
        Tha: '',
        Eng: ''
      },
      otherData: {
        leaveOneDay: null,
        docName: null,
        docFileName: null,
        leaveDayName: null,
        budgetYear: null,
        employeeApproveKeyword: '',
        employeeApprove: {
          ID: null,
          Tha: null,
          Eng: null
        },
        employeeName: {
          Tha: null,
          Eng: null
        },
        positionName: {
          Tha: null,
          Eng: null
        },
        orgNameAll: {
          Tha: null,
          Eng: null
        },
        leaveAssignDateText: null,
        leaveTypeName: null,
        leaveTypeDesc: null
      },
      nextBudgetYearData: {
        has: false,
        budgetYear: null,
        leaveDayName: 'วันทำการ',
        statLeaveLastDay: 0,
        statLeaveNowDay: 0,
        statLeaveTotal: 0,
        warningMessage: ''
      },
      leaveInfo: {},
      employeeApproveList: [],
      leaveSickSelectList: [],
      dataSelect: {},
      leaveApproverStatus: false,
      conDialogOnSubmitSkipUsework: false,
      isFooterShowAll: false
    }
  },

  computed: {
    getdateNowThaFormat() {
      const date = new Date()
      return this.$dateFormatByLang(date, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },
    yearRelexcheck() {
      return !this.form.LimitDay ? '0' : '10'
    },
    leaveCalLimitDayQuota() {
      const res = this.form.LimitDay - this.form.StatLeaveLastDay
      return res
    },
    leaveBalanceQuota() {
      const res = this.leaveCalLimitDayQuota - this.form.LeaveAmountDay
      return res
    },
    leaveOrderId() {
      return this.$route.params.leaveOrderId || '0'
    },

    beginDateText() {
      return this.$dateFormatByLang(this.form.LeaveBeginDate, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },

    finishDateText() {
      return this.$dateFormatByLang(this.form.LeaveFinishDate, {
        format: 'DD MMMM YYYY',
        addUnit: 'Y',
        addValue: '543'
      })
    },
    checkSearch() {
      return this.dataSelect.employeeID ? false : true
    },
    rules() {
      return {
        required: v => !!v || 'กรุณากรอกข้อมูลช่องนี้',
        leavereason: v => v != 0 || 'กรุณาเลือกเหตุผล'
      }
    },

    isLeaveBuss() {
      return this.type === '1'
    },

    isLeaveSick() {
      return this.type === '2'
    },

    isLeaveDeliver() {
      return this.type === '4'
    },

    isLeaveRelax() {
      return this.type === '6'
    },

    isEditMode() {
      return !!this.$route.params.leaveOrderId
    },

    approverTitle() {
      return this.isLeaveRelax && this.form.EmployeeApproveTypeID === 'UseWork'
        ? 'ผู้ปฏิบัติงานแทน'
        : 'ผู้บังคับบัญชา/ผู้ตรวจสอบการลา/ผู้อนุมัติการลา'
    },
    checkActiveDate() {
      if (this.isLeaveRelax) {
        const start = Date.now()
        return this.$dateFormat(start)
      } else {
        return false
      }
    }
  },

  watch: {
    'form.LeaveBeginDate'() {
      if (this.form.LeaveBeginDate >= this.form.LeaveFinishDate) {
        this.form.LeaveFinishDate = this.$dateFormat(this.form.LeaveBeginDate, {
          addValue: 1,
          addUnit: 'd'
        })
      }
    },

    otherData: {
      deep: true,
      handler() {
        this.$emit('updateOtherData', this.otherData)
      }
    },

    loading: {
      deep: true,
      handler() {
        this.$emit('updateLoading', this.loading)
      }
    }
  },

  async mounted() {
    this.leaveInfo = await this.apiGetLeaveInfo()
    const res = await this.apiGetFormSickList()
    this.leaveSickSelectList = [
      {
        leaveReasonID: 0,
        leaveReasonNameTha: '---กรุณาเลือก---',
        leaveReasonNameEng: '---กรุณาเลือก---'
      },
      ...res
    ]
    this.intitialForm()
  },

  methods: {
    intitialForm() {
      this.form = {
        LeaveOrderID: this.leaveOrderId,
        EmployeeID: this.$guid,
        LeaveTypeID: this.type,
        LeaveHead: this.leaveInfo.leaveHead || '',
        LeaveReason: this.leaveInfo.leaveReason || '',
        LeaveBeginDate:
          this.$dateFormat(this.leaveInfo.leaveBeginDate) ||
          new Date().toISOString().substr(0, 10),
        LeaveBeginDayStatusID: this.leaveInfo.leaveBeginDayStatusID || 'ALL',
        LeaveFinishDate:
          this.$dateFormat(this.leaveInfo.leaveFinishDate) ||
          this.$dateFormat(new Date().toISOString().substr(0, 10), {
            addUnit: 'd',
            addValue: 1
          }),
        LeaveFinishDayStatusID: this.leaveInfo.leaveFinishDayStatusID || 'ALL',
        LeaveAmountDay: this.leaveInfo.leaveAmountDay || 0,
        LeaveAmountDayAll: this.leaveInfo.leaveAmountDay || 1,
        CheckSaturday: this.isLeaveDeliver
          ? true
          : this.leaveInfo.checkSaturday
          ? this.leaveInfo.checkSaturday
          : false,
        CheckSunday: this.isLeaveDeliver
          ? true
          : this.leaveInfo.checkSunday
          ? this.leaveInfo.checkSunday
          : false,
        CheckHoliday: this.isLeaveDeliver
          ? true
          : this.leaveInfo.checkHoliday
          ? this.leaveInfo.checkHoliday
          : false,
        LeaveLastBeginDate:
          this.$dateFormat(this.leaveInfo.leaveLastBeginDate) || '',
        LeaveLastFinishDate:
          this.$dateFormat(this.leaveInfo.leaveLastFinishDate) || '',
        LeaveLastAmountDay: this.leaveInfo.leaveLastAmountDay || 0,
        Address: this.leaveInfo.address || '',
        StatLeaveLastDay: this.leaveInfo.statLeaveLastDay || 0,
        StatLeaveNowDay: this.leaveInfo.statLeaveLastDay || 0,
        LimitDay: this.leaveInfo.limitDay || 0,
        Userwork: '',
        SignName: '',
        SignPositionName: '',
        EmployeeApproveID: this.leaveInfo.employeeApproveID || '',
        EmployeeApproveTypeID: this.isLeaveRelax
          ? this.leaveInfo.employeeApproveTypeID
            ? this.leaveInfo.employeeApproveTypeID
            : 'UseWork'
          : 'Approve',
        OverLimitDay: this.leaveInfo.overLimitDay || 0,
        KeepFileFlag: this.leaveInfo.keepFileFlag || true,
        RelaxLastYearDay: this.leaveInfo.relaxLastYearDay || 0,
        LeaveReasonID: this.leaveInfo.leaveReasonID || 0
      }
      //console.log(this.leaveInfo)
      this.otherData = {
        leaveOneDay:
          this.leaveInfo.leaveBeginDate === this.leaveInfo.leaveFinishDate &&
          this.leaveInfo.leaveBeginDayStatusID ===
            this.leaveInfo.leaveFinishDayStatusID,

        leaveLastBeginDate:
          this.$dateFormatByLang(this.leaveInfo.leaveLastBeginDate) || '',
        leaveLastFinishDate:
          this.$dateFormatByLang(this.leaveInfo.leaveLastFinishDate) || '',
        docName: this.leaveInfo.docFileName || null,
        docFileName: null,
        leaveDayName: this.leaveInfo.leaveDayName || 'วันทำการ',
        budgetYear:
          this.leaveInfo.budgetYear || new Date().toISOString().substr(0, 4),
        employeeApproveKeyword: '',
        employeeApprove: {
          ID: this.leaveInfo.employeeApproveNameID,
          Tha: this.leaveInfo.employeeApproveNameTha,
          Eng: this.leaveInfo.employeeApproveNameEng
        },
        employeeName: {
          Tha: this.leaveInfo.employeeNameTha,
          Eng: this.leaveInfo.employeeNameEng
        },
        positionName: {
          Tha: this.leaveInfo.positionNameTha,
          Eng: this.leaveInfo.positionNameEng
        },
        orgNameAll: {
          Tha: this.leaveInfo.orgNameAllTha,
          Eng: this.leaveInfo.orgNameAllEng
        },
        leaveAssignDateText: this.$dateFormatByLang(
          this.leaveInfo.leaveAssignDate
        ),
        leaveTypeName: this.leaveInfo.leaveTypeName,
        leaveTypeDesc: this.leaveInfo.leaveTypeDesc,
        statLeaveTotal:
          parseFloat(this.form.StatLeaveLastDay) +
          parseFloat(this.form.StatLeaveNowDay),
        relaxLastYearDay: this.leaveInfo.relaxLastYearDay || 0,
        warningMessage: ''
      }

      if (this.isLeaveRelax && !this.form.EmployeeApproveID) {
        const approver = this.leaveInfo.approveSendList.find(
          item => item.employeeApproveTypeID === this.form.EmployeeApproveTypeID
        )
        if (approver) {
          this.form.EmployeeApproveID = approver.employeeApproveID
          this.otherData.employeeApprove = {
            ID: approver.employeeApproveNameID,
            Tha: approver.employeeApproveNameTha,
            Eng: approver.employeeApproveNameEng
          }
        }
      }
      // console.log('test1 ' + JSON.stringify(this.form))
      this.onChangeDaySelection()
    },
    openDialog() {
      this.searchDialog = true
      this.employeeApproveList = []
      this.dataSelect = {
        employeeID: '',
        employeeNameTha: '',
        employeeNameEng: '',
        EmployeeApproveID: ''
      }
    },
    onSelectFile() {
      if (event.target.files && event.target.files.length > 0) {
        const filename = event.target.files[0].name.split('.')
        const fileExt = filename[filename.length - 1].toLowerCase()
        const accepted = ['jpg', 'jpeg', 'png', 'pdf']

        if (accepted.includes(fileExt)) {
          this.otherData.docFileName = event.target.files[0]
        } else {
          alert(this.$t('alertErrorMessage.noAcceptFileType'))
          this.otherData.docFileName = ''
        }
      } else {
        this.otherData.docFileName = ''
      }
    },

    async onSearchEmpApprove(keyword) {
      this.otherData.employeeApproveKeyword = keyword
      if (this.otherData.employeeApproveKeyword.length > 1) {
        this.employeeApproveList = await this.apiPostSearchEmployeeByKeyword()
      }
    },

    onSelectApprover(item) {
      this.dataSelect = {
        employeeID: item.employeeID,
        employeeNameTha: item.employeeNameTha,
        employeeNameEng: item.employeeNameEng,
        EmployeeApproveID: item.employeeID
      }
      // this.otherData.employeeApprove.ID = item.employeeID
      // this.otherData.employeeApprove.Tha = item.employeeNameTha
      // this.otherData.employeeApprove.Eng = item.employeeNameEng
      this.form.EmployeeApproveID = item.employeeID
      this.leaveApproverStatus = false
    },
    btnSubmitSelect() {
      this.otherData.employeeApprove.ID = this.dataSelect.employeeID
      this.otherData.employeeApprove.Tha = this.dataSelect.employeeNameTha
      this.otherData.employeeApprove.Eng = this.dataSelect.employeeNameEng
      this.form.EmployeeApproveID = this.dataSelect.EmployeeApproveID
      this.searchDialog = false
    },

    async onChangeDaySelection() {
      const res = await this.apiPostComputeDay()
      const firstItem = res.length > 0 ? res[0] : null
      // console.log(res)
      if (firstItem) {
        this.form.LeaveAmountDay = firstItem.leaveAmountDay || 0
        this.form.LeaveAmountDayAll = firstItem.leaveAmountDayAll || 0
        this.form.LeaveLastAmountDay = firstItem.leaveLastAmountDay || 0
        this.form.LeaveLastBeginDate =
          this.$dateFormat(firstItem.leaveLastBeginDate) || ''
        this.form.LeaveLastFinishDate =
          this.$dateFormat(firstItem.leaveLastFinishDate) || ''
        this.form.StatLeaveLastDay = firstItem.statLeaveLastDay || 0
        this.form.StatLeaveNowDay = firstItem.statLeaveNowDay || 0
        this.form.RelaxLastYearDay = firstItem.relaxLastYearDay || 0
        this.form.OverLimitDay = firstItem.overLimitDay || 0

        this.otherData.leaveLastBeginDate =
          this.$dateFormatByLang(firstItem.leaveLastBeginDate) || ''
        this.otherData.leaveLastFinishDate =
          this.$dateFormatByLang(firstItem.leaveLastFinishDate) || ''
        this.otherData.budgetYear = firstItem.budgetYear
        this.otherData.leaveTypeName = firstItem.leaveTypeName
        this.otherData.leaveTypeDesc = firstItem.comment
        this.otherData.leaveDayName = firstItem.leaveDayName
        this.otherData.statLeaveTotal =
          parseFloat(this.form.StatLeaveLastDay) +
          parseFloat(this.form.StatLeaveNowDay)
        this.otherData.relaxLastYearDay = firstItem.relaxLastYearDay || 0
        this.form.LimitDay = firstItem.limitDay || 0
        this.otherData.warningMessage = firstItem.warningMessage
        this.otherData.overLimitDay = firstItem.overLimitDay
      }

      if (res.length > 1) {
        const secondItem = res[1]
        this.nextBudgetYearData.has = true
        this.nextBudgetYearData.budgetYear = secondItem.budgetYear
        this.nextBudgetYearData.leaveDayName = secondItem.leaveDayName
        this.nextBudgetYearData.statLeaveLastDay =
          secondItem.statLeaveLastDay || 0
        this.nextBudgetYearData.statLeaveNowDay =
          secondItem.statLeaveNowDay || 0
        this.nextBudgetYearData.statLeaveTotal = this.nextBudgetYearData.statLeaveTotal =
          parseFloat(this.nextBudgetYearData.statLeaveLastDay) +
          parseFloat(this.nextBudgetYearData.statLeaveNowDay)
        this.nextBudgetYearData.relaxLastYearDay =
          secondItem.relaxLastYearDay || 0
        this.nextBudgetYearData.limitDay = secondItem.limitDay || 0
        this.nextBudgetYearData.warningMessage = secondItem.warningMessage
      } else {
        this.nextBudgetYearData.has = false
      }

      // if (this.form.LeaveBeginDayStatusID === 'AM') {
      //   this.otherData.leaveOneDay = true;
      // }
    },

    onChangeApproverType(evt) {
      if (
        Array.isArray(this.employeeApproveList) &&
        this.employeeApproveList.length === 0
      ) {
        const approver = this.leaveInfo.approveSendList.find(
          item => item.employeeApproveTypeID === evt
        )

        if (approver) {
          this.form.EmployeeApproveID = approver.employeeApproveID
          this.otherData.employeeApprove = {
            ID: approver.employeeApproveNameID,
            Tha: approver.employeeApproveNameTha,
            Eng: approver.employeeApproveNameEng
          }
        } else {
          this.otherData.employeeApprove = this.employeeApproveDefualt
          this.form.EmployeeApproveID = ''
          // console.log('test ' + JSON.stringify(this.form))
        }
      }
    },

    async onDownloadDocument(item) {
      try {
        const payload = {
          leaveOrderID: item.leaveOrderID,
          docFileName: item.docFileName
        }
        const res = await this.$store.dispatch(
          'leave/getAttachedDocumentDownload',
          payload
        )

        var fileURL = window.URL.createObjectURL(
          new Blob([res.data], { type: 'application/pdf' })
        )
        var link = document.createElement('a')
        link.href = fileURL
        link.download = item.docFileName
        link.click()
      } catch (e) {
        console.log(e.response || e)
      }
    },

    onRemoveAttachedFile() {
      if (confirm('ยืนยันการลบไฟล์แนบ')) {
        this.form.KeepFileFlag = false
      }
    },

    async onSubmitForm() {
      if (
        this.$refs.form.validate() &&
        this.form.EmployeeApproveID &&
        this.form.LeaveAmountDay !== 0
      ) {
        if (
          this.isLeaveRelax &&
          this.form.EmployeeApproveTypeID === 'Approve'
        ) {
          // if(){
          this.conDialogOnSubmitSkipUsework = true
          // }
          //         this.leaveInfo.approveSendList[0].
          // console.log('Check data')
          //check ส่งต่อ null ถ้ามีทำงานปกติ ถ้าไม่มีัถามก่อนว่าจะเลือกมั้ย ถ้าไม่ก็ยืนยัน ถ้าเลือกก็กลับไป ridio แรก
        } else {
          this.conDialogOnSubmitForm = true
        }
        // console.log('test123')
      } else {
        let element = ''
        if (!this.form.LeaveHead) {
          element = 'leaveHead'
        } else if (!this.form.LeaveReason) {
          element = 'leaveReason'
        } else if (this.form.LeaveReasonID === 0) {
          element = 'leaveReasonID'
        }
        // else if (this.form.LeaveAmountDay !== 0) {
        //   element = 'leaveAmountDay'
        //   console.log('test4')
        // }
        else {
          element = 'leaveApprover'
        }
        this.leaveApproverStatus = true

        this.$vuetify.goTo(this.$refs[element], { offset: 20 })
      }
    },
    async conOnSubmitForm() {
      this.conDialogOnSubmitForm = false
      this.conDialogOnSubmitSkipUsework = false
      this.loading1 = true
      try {
        const res = await this.apiPostCreateCommonLeave()
        if (res) {
          this.$router.push('/leave/pending/' + this.$guid)
          this.loading1 = false
        }
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiGetLeaveInfo() {
      this.loading = true
      let body = {
        employeeId: this.$guid,
        leaveOrderId: this.$route.params.leaveOrderId || 0,
        leaveType: this.type
      }
      let action = 'leave/getRelaxInfo'

      if (this.type !== '6') {
        body.leaveType = this.type
        action = 'leave/getInfoByLeaveOrderID'
      }

      try {
        const res = await this.$store.dispatch(action, body)
        return res.data?.data[0] || {}
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostSearchEmployeeByKeyword() {
      this.loading = true
      const body = {
        Keyword: this.otherData.employeeApproveKeyword
      }
      try {
        const res = await this.$store.dispatch(
          'leave/postSearchEmployeeByKeyword',
          body
        )
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiGetFormSickList() {
      this.loading = true
      try {
        const res = await this.$store.dispatch('leave/getFormSickList')
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostComputeDay() {
      this.loading = true
      const finishDate =
        this.otherData.leaveOneDay || this.form.LeaveBeginDayStatusID === 'AM'
          ? this.form.LeaveBeginDate
          : this.form.LeaveBeginDate >= this.form.LeaveFinishDate
          ? this.$dateFormat(this.form.LeaveBeginDate, {
              addUnit: 'd',
              addValue: 1
            })
          : this.form.LeaveFinishDate

      const body = {
        EmployeeID: this.$guid,
        LeaveTypeID: this.type,
        LeaveBeginDate: this.form.LeaveBeginDate,
        LeaveBeginDayStatusID: this.form.LeaveBeginDayStatusID,
        LeaveFinishDate: finishDate,
        LeaveFinishDayStatusID: this.form.LeaveFinishDayStatusID,
        CheckSaturday: this.form.CheckSaturday,
        CheckSunday: this.form.CheckSunday,
        CheckHoliday: this.form.CheckHoliday
      }
      try {
        const res = await this.$store.dispatch('leave/postComputeDay', body)
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    },

    async apiPostCreateCommonLeave() {
      this.loading = true
      try {
        let formData = new FormData()
        let formStringConverted = {}
        for (const [key, value] of Object.entries(this.form)) {
          // console.log(`${key} : ${value}`)
          if (typeof value === 'boolean') {
            formStringConverted[key] = value ? 'true' : 'false'
          } else if (typeof value === 'number') {
            formStringConverted[key] = value.toString()
          } else {
            formStringConverted[key] = value ? value.toString() : ''
          }
        }

        if (
          this.otherData.leaveOneDay ||
          formStringConverted.LeaveBeginDayStatusID === 'AM'
        ) {
          formStringConverted.LeaveFinishDate =
            formStringConverted.LeaveBeginDate
          formStringConverted.LeaveFinishDayStatusID =
            formStringConverted.LeaveBeginDayStatusID
        }

        formStringConverted.SignName = ''
        formStringConverted.SignPositionName = ''

        if (this.otherData.docFileName) {
          formStringConverted.KeepFileFlag = 'false'
          formData.append('filename1', this.otherData.docFileName)
        }
        formData.append('dataEform', JSON.stringify(formStringConverted))

        // for (let pair of formData.entries()) {
        //   console.log(pair[0] + ', ' + pair[1])
        // }

        let action = 'leave/postCreateCommonLeave'

        if (this.isLeaveRelax) {
          action = 'leave/postCreateRelaxLeave'
        }

        const res = await this.$store.dispatch(action, formData)
        return res.data?.data || []
      } catch (e) {
        console.log(e.response || e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-file-input {
  flex-direction: row-reverse;
}
.fixposition {
  position: sticky;
  top: 7%;
}
.shadowBox {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 20px rgba(7, 77, 168, 0.19),
    0 2px 2px rgba(13, 112, 193, 0.23);
  border-style: solid;
  border-width: thin;
  border-color: #1c63ba;
}
</style>
